module.exports = __webpack_public_path__ + "img/home.9f9c6653.png";